import { render } from "./PaymentDropdown.vue?vue&type=template&id=4774650e"
import script from "./PaymentDropdown.vue?vue&type=script&lang=js"
export * from "./PaymentDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__